<p-dialog
    [header]="'pr.EditExtraTitle'|translate"
    [modal]="true"
    [resizable]="false"
    [(visible)]="dialogOpen"
    class="extraDialog"
    [style]="{ width: '600px' }"
    [breakpoints]="{ '1199px': '600px', '575px': '90vw' }"
    [draggable]="false"
    [attr.data-testid]="testId"
>
    <div class="extraDialogContent">
        @if (extrasToEdit) {
            <div class="row">
                <div class="col-12">
                    <img
                    [src]="extrasToEdit[0].imageUrl ?? extrasToEdit[0].pim?.images?.[0]?.src ?? '/image-placeholder.jpeg'"
                    [alt]="extrasToEdit[0].pim?.name"
                    class="extra-image" />
                </div>

                <h2 class="mt-3 extra-dialog-title" [attr.data-testid]="testId + '-title'">{{extrasToEdit[0].pim?.name ?? extrasToEdit[0].extraName}} <span class="extra-dialog-title-price" [attr.data-testid]="testId + '-price'">{{(unitPrice ?? extrasToEdit[0].totalPriceForStayWithTaxes)|currency}}@if (unitPriceLabel) { <span class="extra-price-breakdown">{{unitPriceLabel|translate}}</span>}</span></h2>
                @if (extrasToEdit[0].externalId) {
                    <div class="mb-2 extra-description" [innerHTML]="extrasToEdit[0].description"></div>
                }
                @else {
                    <div class="mb-2 extra-description" [innerHTML]="extrasToEdit[0].pim?.longDesc"></div>
                }

                @if (extrasToEdit[0].event) {

                    <p class="d-flex gap-2">
                        <span class="material-symbols-outlined">
                        event
                        </span>
                        {{extrasToEdit[0].event.startDate|date:'dd.MM.yyyy HH:mm'}}@if(extrasToEdit[0].event.endDate != extrasToEdit[0].event.startDate){ - {{extrasToEdit[0].event.endDate|date:'dd.MM.yyyy HH:mm'}}}
                    </p>
                    <p><b>{{'pr.eventLocation'|translate}}</b></p>
                    <p>
                        @if (extrasToEdit[0].event.venue.name){{{extrasToEdit[0].event.venue.name}}<br>}
                        @if (extrasToEdit[0].event.venue.address){{{extrasToEdit[0].event.venue.address}}<br>}
                        @if (extrasToEdit[0].event.venue.city){{{extrasToEdit[0].event.venue.city}}<br>}
                    </p>
                }

                @for (e of extrasToEdit; track $index) {
                <div class="col-12 extra-dialog-selector-container" [class.col-md-6]="$count > 0" [class.mt-3]="$index > 1">
                    <label for="room">
                        @if (isFixedExtra(e)) {
                            @if ($count > 1) {
                                <b>{{"pr.Room"|translate}} {{$index + 1}}</b>:<br>
                                {{rooms[$index].item?.room.pim?.name ?? rooms[$index].item.room.roomName}}
                            }
                        }
                        @else if ($count > 1) {
                            <b>{{"pr.QuantityForRoom"|translate}} {{$index + 1}}</b>:<br>
                            {{rooms[$index].item?.room.pim?.name ?? rooms[$index].item.room.roomName}}
                        }
                        @else {
                            {{"pr.Quantity"|translate}}
                        }
                    </label>

                    @if (e.appliedRules?.rooms?.[$index]?.hidden || !e.availableRoomIndexes?.includes($index)) {
                        <div class="error-text" [attr.data-testid]="testId + '-error'">{{"pr.notPossibleToSelectForThisRoom"|translate}}</div>
                    }
                    @else if (isCheckboxExtra(e)) {
                        <app-incrementor
                            [value]="e.quantity"
                            minValue="0"
                            [maxErrorText]="'pr.extraMaxValue'|translate:{value: 1}"
                            [maxValue]="1"
                            (onChange)="onEditQuantityChange($event, $index)"
                            [dataTestId]="testId">
                        </app-incrementor>
                    }
                    @else if (isFixedExtra(e)) {
                        @if (e.quantity > 0) {
                            <div class="extra-fixed-toggle d-flex align-items-center gap-2">
                                <p-tag class="extra-added-label">{{"pr.extraAdded"|translate}}</p-tag>
                                <p-button [outlined]="true" (onClick)="onEditQuantityChange(0, $index)" [attr.data-testid]="testId + '-remove'">{{"pr.removeExtra"|translate}}</p-button>
                            </div>
                        }
                        @else {
                            <p-button (onClick)="onEditQuantityChange(1, $index)" [attr.data-testid]="testId + '-add'">{{"pr.AddExtra"|translate}}</p-button>
                        }
                    }
                    @else {
                        <app-incrementor
                            [value]="e.quantity"
                            minValue="0"
                            [maxErrorText]="'pr.extraMaxValue'|translate:{value: getExtraMaxQtyForRoom(e, $index)}"
                            [maxValue]="getExtraMaxQtyForRoom(e, $index)"
                            (onChange)="onEditQuantityChange($event, $index)"
                            [dataTestId]="testId">
                        </app-incrementor>
                    }

                    @if (!(e.appliedRules?.rooms?.[$index]?.hidden || !e.availableRoomIndexes?.includes($index))) {
                        @if (e.calculationRule === 'adult') {
                        <span class="extra-summary-note">{{ 'pr.extraNoteAdults' | translate: {count: adultsPerRoom[$index]} }}</span>
                        }
                        @if (e.calculationRule === 'child') {
                            <span class="extra-summary-note">{{ 'pr.extraNoteChildren' | translate: {count: childrenPerRoom[$index]} }}</span>
                        }
                        @if (e.calculationRule === 'person') {
                            <span class="extra-summary-note">{{ 'pr.extraNotePersons' | translate: {count: adultsPerRoom[$index] + childrenPerRoom[$index]} }}</span>
                        }
                        @if (e.postingRhythm === 'day') {
                            <span class="extra-summary-note">{{ 'pr.extraNoteDays' | translate: {count: nights} }}</span>
                        }
                    }
                    

                </div>
                }
            </div>
            <div class="extra-dialog-bottom">
                <p-button [outlined]="true" (click)="closeClick()" [attr.data-testid]="testId + '-close'">{{"pr.close"|translate}}</p-button>
            </div>
        }

    </div>
</p-dialog>
